import type { JiraUserBoardNavigationData } from '@jira/navigation-apps__resources/src/services/sidebar/jsw-userboard-sidebar-navigation/types.tsx';
import type { ProjectSidebarNavInfo } from '@jira/navigation-apps__resources/src/services/sidebar/project-sidebar-navigation/types.tsx';
import { extractData, getStyle } from '@jira/navigation-apps__sidebar-utils/src/extractData.tsx';
import {
	type ProjectType,
	CORE_PROJECT,
	SERVICE_DESK_PROJECT,
	SOFTWARE_PROJECT,
	PRODUCT_DISCOVERY_PROJECT,
	CUSTOMER_SERVICE_PROJECT,
} from '@jira/platform__project-types/src/project-types.tsx';
import type { ProjectContext, UserContext, Scope } from '../../types.tsx';

export const getUserContext = (userBoardNavData: JiraUserBoardNavigationData): UserContext => {
	const { boardInfo, owner } = userBoardNavData;
	return {
		contextType: 'user',
		user: {
			id: owner.id,
			name: owner.name,
			avatarUrl: owner.avatarUrl,
			profileUrl: owner.profileUrl,
			accountId: owner.accountId,
		},
		scope: {
			id: boardInfo.id,
			type: boardInfo.type,
			name: boardInfo.name,
		},
	};
};

const getScope = (projectNavInfo: ProjectSidebarNavInfo): Scope | undefined => {
	if (
		projectNavInfo.projectType === 'jira_software' &&
		projectNavInfo?.jiraSoftwareNavData?.boardInfo
	) {
		const { boardInfo } = projectNavInfo.jiraSoftwareNavData;
		return {
			id: boardInfo.id,
			type: boardInfo.type,
			name: boardInfo.name,
		};
	}
	return undefined;
};

const getProjectType = (projectType: string): ProjectType | null => {
	switch (projectType) {
		case 'business':
			return CORE_PROJECT;
		case 'software':
			return SOFTWARE_PROJECT;
		case 'service_desk':
			return SERVICE_DESK_PROJECT;
		case 'product_discovery':
			return PRODUCT_DISCOVERY_PROJECT;
		case 'customer_service':
			return CUSTOMER_SERVICE_PROJECT;
		default:
			return null;
	}
};

export const getProjectContext = (projectNavInfo: ProjectSidebarNavInfo): ProjectContext | null => {
	const project = extractData(projectNavInfo);
	const scope = getScope(projectNavInfo);

	if (project) {
		const projectType = getProjectType(project.type);
		if (projectType) {
			return {
				contextType: 'project',
				project: {
					key: project.key,
					// @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
					id: project.id,
					name: project.name,
					type: projectType,
					isSimplified: project.isSimplified,
					avatarUrl: project.avatarUrl,
					style: getStyle(project.isSimplified),
				},
				scope,
			};
		}
	}
	return null;
};
